import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';
import { PricingService } from 'src/app/services/pricing.service';
import { AddCorporateGroupComponent } from './add-corporate-group/add-corporate-group.component';

@Component({
  selector: 'app-corporate-group',
  templateUrl: './corporate-group.component.html',
  styleUrls: ['./corporate-group.component.css']
})
export class CorporateGroupComponent implements OnInit {

  data: any;
  models: any;
  constructor(
    private priceService: PricingService,
    private globalService: GlobalService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getCorporateGroup();
  }

  getCorporateGroup(): void {
    this.priceService.getCorporateGroupList().subscribe({
      next: (result) => {
        this.data = result.data;
      },
      error: this.globalService.handleError
    });
    this.priceService.getCorporateList().subscribe({
      next: (result) => {
        this.models = result.data;
      },
      error: this.globalService.handleError
    });
  }

  addCorporateGroup(): void {
    this.dialog.open(AddCorporateGroupComponent, {
      data: this.models,
      minWidth: "400px",
    }).afterClosed().subscribe({
      next: (result) => {
        this.getCorporateGroup();
      }
    })
  }
  removeGroup(id: number): void {
    if (confirm('Are you sure ?')) {
      this.priceService.deleteCorporateGroup(id).subscribe({
        next: (result) => {
          this.globalService.successMessage(result)
          this.getCorporateGroup();
        },
        error: this.globalService.handleError
      });
    }
  }
}
